import React, { useState, forwardRef } from 'react';
import styles from './GlobalTextarea.module.css';

export interface GlobalTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  error?: string;
  showErrorText?: boolean;
}

export const GlobalTextarea = forwardRef<HTMLTextAreaElement, GlobalTextareaProps>(
  ({ label, error, className, value, disabled, showErrorText = true, ...props }, ref) => {
    const [isFocused, setIsFocused] = useState(false);

    const hasValue =
      value !== undefined && value !== null
        ? String(value).length > 0
        : false;

    const handleFocus = (e: React.FocusEvent<HTMLTextAreaElement>) => {
      if (!disabled) {
        setIsFocused(true);
        props.onFocus?.(e);
      }
    };

    const handleBlur = (e: React.FocusEvent<HTMLTextAreaElement>) => {
      setIsFocused(false);
      props.onBlur?.(e);
    };

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      if (!disabled) {
        props.onChange?.(e);
      }
    };

    return (
      <div className={`${styles.inputContainer} ${disabled ? styles.disabled : ''} ${className || ''}`}>
        <div className={`${styles.inputWrapper} ${disabled ? styles.wrapperDisabled : ''}`}>
          <textarea
            {...props}
            ref={ref}
            value={value}
            disabled={disabled}
            className={`${styles.textarea} ${error ? styles.error : ''} ${isFocused ? styles.focused : ''} ${hasValue ? styles.hasValue : ''} ${disabled ? styles.textareaDisabled : ''}`}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={handleChange}
            placeholder=" "
          />
          <label className={styles.label}>{label}</label>
        </div>
        {error && showErrorText && <span className={styles.errorMessage}>{error}</span>}
      </div>
    );
  }
);

GlobalTextarea.displayName = 'GlobalTextarea';
